import type { ComponentProps } from "react";

import { cn } from "@lawline/ui/core/cn";

const VARIANTS = {
	default: "text-foreground",
	destructive: "text-destructive",
} as const;

// Presentational only. The caller positions it, for example with
// `fixed top-4 left-1/2 -translate-x-1/2 z-50` for a centered banner.
export function Notification({
	variant = "default",
	className,
	...props
}: ComponentProps<"div"> & { variant?: keyof typeof VARIANTS }) {
	return (
		<div
			role="status"
			className={cn(
				"inline-flex items-center gap-2 px-4 py-2 font-medium text-sm [&>svg]:size-4 [&>svg]:shrink-0",
				VARIANTS[variant],
				className,
			)}
			{...props}
		/>
	);
}
